import { Component, Prop, State, h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'qumra-color-input',
  styleUrl: 'qumra-color-input.css',
  shadow: false,
})
export class QumraColorInput {
  @Event() optionChange: EventEmitter<any>;

  @Prop() data: string;
  @Prop() selected: string;

  @State() properties: any;
  @State() selectedValue: string;

  componentWillLoad() {
    this.properties = JSON.parse(this.data);
    this.selectedValue = this.selected;
  }

  handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.selectedValue = target.value;
    this.optionChange.emit({ property: this.properties.id, value: this.selectedValue });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px',with:"100%" }}>
        {this.properties.values.map(value => (
          <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}>
            <input
              type="radio"
              id={`color-${value.id}`}
              name={`property[${this.properties.id}]`}
              value={value.id}
              style={{ display: 'none' }}
              onChange={this.handleChange.bind(this)}
              checked={this.selectedValue === value.id}
            />
            <div
              style={{
                padding: '2px',
                borderRadius: '999999999999999999999px',
                outlineStyle: 'solid',
                outlineColor: this.selectedValue === value.id ? 'var(--mainColor)' : 'transparent',
                outlineWidth: '2px',
              }}
            >
                    <div
              style={{
                width: '26px',
                height: '26px',
                borderRadius: '999999999999999999999px',
                backgroundColor: value.value,
              }}
            ></div>
            </div>
          </label>
        ))}
      </div>
    );
  }
}
